module.exports = __webpack_public_path__ + "img/AI small.1ee4ad50.svg";